<script>
import headersPublic from "@/views/app/dashboard/battleground/data/headers-public";

import DataTableGolden from "@/components/tables/DataTableGolden.vue";

export default {
  name: "GameHistoryPrivate",

  components: { DataTableGolden },

  props: {
    isMobile: { type: Boolean, required: false, default: false },
  },

  data: () => ({
    headersPublic: headersPublic,
    itemsPublic: [
      {
        gameId: "838",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "856",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "859",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "862",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "864",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "875",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "875",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "862",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "864",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "875",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "875",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "838",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "856",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "859",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "862",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "864",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "875",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "875",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "862",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "864",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "875",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "875",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "838",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "856",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "859",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "862",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "864",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "875",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "875",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "862",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "864",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "875",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
      {
        gameId: "875",
        buyIn: "testPrivate",
        rank: "testPrivate",
        prizeWin: "-",
        date: "testPrivate",
      },
    ],
  }),
};
</script>

<template>
  <data-table-golden
    :items="itemsPublic"
    :headers="headersPublic"
    :is-mobile="isMobile"
  />
</template>

<style scoped lang="scss"></style>
